<template>
  <div
    v-if="peer_uid ==='' || chat_list.length===0"
    class="chat_middle"
  >
    <div class="no_message">
      <img
        src="http://img.yimutian.com/misc/5cc694666ef1434e6e56525da0f336c7.png"
        alt=""
      >
      <p>{{ chat_list && chat_list.length ?'未选择聊天':'没有聊天内容' }}</p>
    </div>
  </div>
  <div
    v-else
    class="chat_middle select_message flex1"
  >
    <div class="chat_middle_top">
      {{ peer_name }}
      <el-popover
        v-if="isDouniu"
        :ref="'popover_'+peer_uid"
        placement="top"
        width="160"
      >
        <p>姓名：{{ peer_name }}</p>
        <p>ID：{{ peer_uid }}</p>
        <p>手机：{{ mobile }}</p>
        <el-button
          slot="reference"
          class="el_btn"
        />
      </el-popover>
    </div>
    <div
      ref="list"
      class="chat_middle_chatting overflow_style"
      @scroll="throttle"
    >
      <div
        v-loading="loadding"
        v-if="hasMsgData"
        class="loadding"
      >
        <!-- <mt-spinner type="fading-circle" v-if="loadding"></mt-spinner> -->
      </div>
      <div
        v-for="(item,index) in message_list"
        :key="index"
      >
        <div
          v-if="item.customer_id === peer_uid && (item.msg_type===1 ||item.msg_type===7|| item.msg_type===8|| item.msg_type===10||item.msg_type===11 || item.msg_type===12)"
          class="buble you"
        >
          <img
            :src="item.icon_url || defalutIconUrl | aspectFit(44, 44)"
            alt
          >
          <div class="messageBox">
            <span class="message">{{ item.content }}</span>
          </div>
          <span class="time">{{ item.action_time | formatTime('yyyy.M.d hh:mm') }}</span>
        </div>
        <div
          v-if="item.customer_id !== peer_uid && (item.msg_type===1 ||item.msg_type===7|| item.msg_type===8|| item.msg_type===10||item.msg_type===11 || item.msg_type===12)"
          class="buble me"
        >
          <div class="messageBox">
            <span class="message">{{ item.content }}</span>
          </div>
          <img
            :src="icon_url_me || 'http://s.yimutian.com/avatar/aben.jpg'| aspectFit(44, 44)"
            alt
          >
          <span class="time">{{ item.action_time | formatTime('yyyy.M.d hh:mm') }}</span>
        </div>
        <div
          v-if="item.customer_id === peer_uid && item.msg_type===3"
          class="buble you"
        >
          <img
            :src="item.icon_url || defalutIconUrl | aspectFit(44, 44)"
            alt
          >
          <div class="messageBox">
            <span
              class="message"
              @click="playVoice($event,index)"
            >
              <div class="audios">
                <audio
                  :src="meta(item.meta).voice_url | getVoiceUrl"
                  class="audio"
                />
                <img
                  v-if="(index===voiceIndex && isPlaying)"
                  src="http://img.yimutian.com/misc/5cd53ecc5c26555cbd16d7ccb2abe206.gif"
                  alt=""
                >
                <img
                  v-else
                  src="http://img.yimutian.com/misc/5cc694ab5c26555cbd16bfcdb169a9ea.png"
                  alt=""
                >
              </div>
              <!-- <div class="layer" :class="{'animations':index===voiceIndex && isPlaying}">
            </div> -->
              <!-- <div class="audio">
              <div class="item first"></div>
              <div class="item second"></div>
              <div class="item third"></div>
            </div> -->
              <p
                :style="audioWidth(meta(item.meta).duration)"
                class="audio_time"
              >{{ meta(item.meta).duration }}
                '</p>
            </span>
          </div>
          <span class="time">{{ item.action_time | formatTime('yyyy.M.d hh:mm') }}</span>
        </div>
        <div
          v-if="item.customer_id !== peer_uid && item.msg_type===3"
          class="buble me"
        >
          <div class="messageBox">
            <span
              class="message"
              @click="playVoice($event,index)"
            >
              <p
                :style="audioWidth(meta(item.meta).duration)"
                class="audio_time"
              >{{ meta(item.meta).duration }}
                '</p>
              <div class="audios">
                <audio
                  :src="meta(item.meta).voice_url | getVoiceUrl"
                  class="audio"
                />
                <img
                  v-if="(index===voiceIndex && isPlaying)"
                  src="http://img.yimutian.com/idcard/5cdbd4596ef1434e6e60972a9b72f9be-100-100C.gif"
                  alt=""
                >
                <img
                  v-else
                  class="origin"
                  src="http://img.yimutian.com/misc/5ced00927960423e1104e637779b3b0e.png"
                  alt=""
                >
              </div>
              <!-- <div class="audio">
              <div class="item first"></div>
              <div class="item second"></div>
              <div class="item third"></div>
            </div> -->
            </span>
          </div>
          <img
            :src="icon_url_me || 'http://s.yimutian.com/avatar/aben.jpg' | aspectFit(44, 44)"
            alt
          >
          <span class="time">{{ item.action_time | formatTime('yyyy.M.d hh:mm') }}</span>
        </div>
        <div
          v-if="item.customer_id === peer_uid && item.msg_type===9"
          class="buble you"
        >
          <img
            :src="item.icon_url || defalutIconUrl | aspectFit(44, 44)"
            alt
          >
          <div class="payment">
            <div class="payment_info">
              <div class="payment_icon">
                ¥
              </div>
              <div class="payment_content">
                <span>订单金额:{{ meta(item.meta).order_cost/100 }}元</span>
                <span>{{ meta(item.meta).amount }}{{ meta(item.meta).unit |
                getUnitName }}{{ meta(item.meta).product_name+' '+(meta(item.meta).product_spec ?
                meta(item.meta).product_spec:'') }}</span>
              </div>
            </div>
            <div class="payment_remark">
              一亩田线上担保交易
            </div>
          </div>
          <span class="time">{{ item.action_time | formatTime('yyyy.M.d hh:mm') }}</span>
        </div>
        <div
          v-if="item.customer_id !== peer_uid && item.msg_type===9"
          class="buble me"
        >
          <div class="payment">
            <div class="payment_info">
              <div class="payment_icon">
                ¥
              </div>
              <div class="payment_content">
                <span>订单金额:{{ meta(item.meta).order_cost/100 }}元</span>
                <span>{{ meta(item.meta).amount }}{{ meta(item.meta).unit |
                getUnitName }}{{ meta(item.meta).product_name+' '+(meta(item.meta).product_spec ?
                meta(item.meta).product_spec:'') }}</span>
              </div>
            </div>
            <div class="payment_remark">
              一亩田线上担保交易
            </div>
          </div>
          <img
            :src="icon_url_me || 'http://s.yimutian.com/avatar/aben.jpg' | aspectFit(44, 44)"
            alt
          >
          <span class="time">{{ item.action_time | formatTime('yyyy.M.d hh:mm') }}</span>
        </div>
        <div
          v-if="item.customer_id === peer_uid && (item.msg_type===2 || item.msg_type===5)"
          class="buble you"
        >
          <img
            :src="item.icon_url || defalutIconUrl | aspectFit(44, 44)"
            alt
          >
          <div class="message_img pointer">
            <div
              v-if="item.msg_type===5"
              @click.stop="playvideo(meta(item.meta).video_url)"
            >
              <img
                class="video_icon"
                src="http://img.yimutian.com/idcard/5cde1e156400816b268fdc4ce79c1b25-100-100C.png"
                alt=""
              >
              <img
                :style="{'max-width': '180px', 'max-height': '180px',background: '#000000'}"
                :src="meta(item.meta).preview_url_uploaded | aspectFit(180, 180)"
                alt=""
              >
            </div>
            <vue-preview
              :list="slide(meta(item.meta))"
              :thumb-image-style="{'max-width': '180px', 'max-height': '180px', 'border-radius': '4px'}"
              @close="handleClose"
            >
              <img
                :style="{'max-width': '180px', 'max-height': '180px',background: '#000000'}"
                :src="meta(item.meta).img_url | aspectFit(180, 180)"
                alt=""
              >
            </vue-preview>
            <!-- <img :src="meta(item.meta).img_url" @click="viewImg(meta(item.meta).img_url)" class="preview-img">  -->
          </div>
          <span class="time">{{ item.action_time | formatTime('yyyy.M.d hh:mm') }}</span>
        </div>
        <div
          v-if="item.customer_id !== peer_uid && (item.msg_type===2 || item.msg_type===5)"
          class="buble me"
        >
          <div class="message_img pointer">
            <div
              v-if="item.msg_type===5"
              @click.stop="playvideo(meta(item.meta).video_url)"
            >
              <img
                class="video_icon"
                src="http://img.yimutian.com/idcard/5cde1e156400816b268fdc4ce79c1b25-100-100C.png"
                alt=""
              >
              <img
                :style="{'max-width': '180px', 'max-height': '180px',background: '#000000'}"
                :src="meta(item.meta).preview_url_uploaded | aspectFit(180, 180)"
                alt=""
              >
            </div>
            <vue-preview
              :list="slide(meta(item.meta))"
              :thumb-image-style="{'max-width': '180px', 'max-height': '180px', 'border-radius': '4px'}"
              @close="handleClose"
            >
              <img
                :style="{'max-width': '180px', 'max-height': '180px',background: '#000000'}"
                :src="meta(item.meta).img_url | aspectFit(180, 180)"
                alt=""
              >
            </vue-preview>
            <!-- <template>
              <img :src="meta(item.meta).img_url" @click="viewImg($preview)" class="preview-img">
            </template> -->
            <!-- <img class="preview-img" v-for="(items, indexs) in list" :src="items.src" height="100" @click="viewImg($event)"/> -->
          </div>
          <img
            :src="icon_url_me || 'http://s.yimutian.com/avatar/aben.jpg' | aspectFit(44, 44)"
            alt
          >
          <span class="time">{{ item.action_time | formatTime('yyyy.M.d hh:mm') }}</span>
        </div>

        <div
          v-if="item.type==='order_card'"
          class="buble"
        >
          <div class="message_order_status">
            <p class="title">
              {{ item.card.title }}
            </p>
            <p
              class="status"
              v-html="item.card.content"
            />
          </div>
        </div>
        <div
          v-if="item.customer_id === peer_uid && item.msg_type===6"
          class="buble you"
        >
          <img
            :src="item.icon_url || defalutIconUrl | aspectFit(44, 44)"
            alt
          >
          <div class="message_shop_info">
            <div class="message_shop_icon">
              <img :src="meta(item.meta).product_img">
            </div>
            <div class="message_shop_content">
              <p>{{ meta(item.meta).product_name }}</p>
              <p class="price">
                {{ meta(item.meta).price }}元/{{ meta(item.meta).price_unit |
                getUnitName }}
              </p>
            </div>
          </div>
          <span class="time">{{ item.action_time | formatTime('yyyy.M.d hh:mm') }}</span>
        </div>
        <div
          v-if="item.customer_id !== peer_uid && item.msg_type===6"
          class="buble me"
        >
          <div class="message_shop_info">
            <div class="message_shop_icon">
              <img :src="meta(item.meta).product_img">
            </div>
            <div class="message_shop_content">
              <p>{{ meta(item.meta).product_name }}</p>
              <p class="price">
                {{ meta(item.meta).price }}元/{{ meta(item.meta).price_unit |
                getUnitName }}
              </p>
            </div>
          </div>
          <img
            :src="icon_url_me || 'http://s.yimutian.com/avatar/aben.jpg' | aspectFit(44, 44)"
            alt
          >
          <span class="time">{{ item.action_time | formatTime('yyyy.M.d hh:mm') }}</span>
        </div>
      </div>
    </div>
    <div class="chat_middle_bottom">
      <textarea
        ref="textarea"
        v-model="messageValue"
        placeholder="请在此输入"
        maxlength="500"
        @keyup.enter="sendMessage($event,1)"
      />
      <div class="media_bar">
        <div class="emoji_img pointer">
          <div
            class="emoji"
            @click.stop="showEmoji=!showEmoji"
          >
            <img
              src="http://img.yimutian.com/misc/5cc693d46ef1434e6e5651f370c1d65f.png"
              alt=""
            >
          </div>
          <div class="img">
            <file-upload
              ref="upload"
              v-model="files"
              :multiple="false"
              :size="1024 * 1024 * 10"
              class="upload_btn"
              name="imgfile"
              post-action="https://gfw.ymt.com/img/upload?bucket=crm"
              extensions="gif,jpg,jpeg,png,webp"
              accept="image/png, image/gif, image/jpeg, image/webp"
              @input-filter="inputFilter"
              @input-file="inputFile"
            >
              <img
                class="upload_img"
                src="http://img.yimutian.com/misc/5cc694195c26555cbd16bfc8217b841f.png"
              >
            </file-upload>
            <!-- <img src="http://img.yimutian.com/misc/5cc694195c26555cbd16bfc8217b841f.png" alt=""> -->
          </div>
        </div>
        <div class="sendDes">
          <button
            :disabled="isdisabledFn"
            class="chat_right_btn global_btn btn_g"
            type="button"
            @click.prevent="sendMessage($event,1)"
          >
            发送
          </button>
        </div>
      </div>
    </div>
    <!-- emoji弹框 -->
    <div
      v-show="showEmoji"
      class="emoji_dialog pointer"
    >
      <ul>
        <li
          v-for="(item,index) in emojiList"
          :key="index"
          class="emoji_item"
          @click.prevent="addEmoji(item)"
        >
          {{ item }}
        </li>
      </ul>
    </div>
    <!-- 上传图片 -->
    <div
      v-show="showpreview"
      class="img_preview"
    >
      <div class="img_content">
        <img
          v-for="(file,index) in files"
          :key="index"
          :src="file.blob"
          alt=""
        >
      </div>
      <div class="btn">
        <button
          class="cancel chat_right_btn global_btn"
          @click.prevent="showpreview=false"
        >
          取消
        </button>
        <div class="space" />
        <button
          v-show="!$refs.upload || !$refs.upload.active"
          class="confirm chat_right_btn global_btn btn_g"
          @click.prevent="confirmImg($event)"
        >
          发送
        </button>
      </div>
    </div>
    <div
      v-if="isPlayvideo"
      class="video_mask"
    >
      <!-- <div class="mask_relative"> -->
      <img
        class="close pointer"
        src="http://img.yimutian.com/idcard/5cde1e526400816b268fdc770a3cb021-100-100C.png"
        alt=""
        @click="closeVideo"
      >
      <!-- </div> -->
      <video
        :controls="isPlayvideo"
        :src="videoSrc"
        autoplay="autoplay"
        style="background:#000000;width:100%;height:100%;z-index:11;position:relative"
      />
    </div>
  </div>
  <!-- </div> -->
</template>
<script>
import { chat } from '@/api.js'
import { mapState, mapActions, mapGetters } from 'vuex'
import fileUpload from '@ymt/vue-upload-component'
import emojiList from '@/emoji/index.js'
import * as utils from '@/utils.js'
export default {
  components: {
    fileUpload
  },
  filters: {
    getVoiceUrl: function(value) {
      return value.replace(/amr/g, 'ogg')
    }
  },
  props: {
    isDouniu: Boolean
  },
  data() {
    return {
      icon_url_me: localStorage.getItem('portrait'),
      messageValue: '',
      isPlaying: false,
      onSale: 1,
      page: 0,
      audioUrl: '',
      files: [],
      filename: '',
      emojiList: emojiList,
      showpreview: false,
      showEmoji: false,
      msgParam: {
        peer_uid: this.peer_uid,
        peer_type: 0,
        start_id: 0, // 起始id
        limit: 100, // 这个在php层加上
        dialog_id: this.dialog_id,
        dialog_type: 0
      },
      loadding: false,
      voiceIndex: '',
      needAck: false,
      isPlayvideo: false,
      videoSrc: '',
      disabled: true
    }
  },
  computed: {
    ...mapGetters('chat', ['message_ids', 'peer_name', 'dialog_id', 'mobile']),
    ...mapState('chat', [
      'chat_list',
      'peer_uid',
      'message_list',
      'msgTimestamp',
      'chatListTimestamp',
      'sendTimestamp',
      'hasMsgData',
      'loadType',
      'unread',
      'defalutIconUrl'
    ]),
    meta() {
      return value => {
        if (utils.isJsonString(value)) {
          return JSON.parse(value)
        }
        return value
      }
    },
    slide() {
      return value => {
        return [
          {
            src: value.img_url,
            w: value.img_width > 100 ? value.img_width * 2 : 100,
            h: value.img_height > 100 ? value.img_height * 2 : 100
          }
        ]
      }
    },
    audioWidth() {
      return value => {
        let width = 0.1 * value + 'rem'
        return {
          width: width
        }
      }
    },
    isdisabledFn() {
      this.messageValue = this.messageValue
        .replace(/[\r\n]/g, '')
        .replace(/\ +/g, '')
      return !this.messageValue
    }
  },
  watch: {
    message_list() {
      if (this.loadType === 1) {
        this.$nextTick(this.scroll)
      }
    },
    peer_uid() {
      this.msgParam.start_id = 0
      this.$store.state.chat.hasMsgData = true
      this.$store.state.chat.message_list = []
      this.pullHistoryMsg()
    },
    chatListTimestamp() {
      if (this.loadType === 1) {
        this.newMsgAll({}).then(() => {
          this.ackById()
        })
      }
    }
  },
  mounted() {
    this.scroll()
    if (this.peer_uid && !this.message_list.length) {
      this.pullHistoryMsg()
        .then(() => {
          this.needAck = true
          // this.newMsgAll({})
        })
        .then(() => {
          this.ackById()
        })
    }
    document.addEventListener('click', e => {
      if (
        e.target.className &&
        e.target.className.indexOf('video_mask') === -1 &&
        this.isPlayvideo
      ) {
        this.isPlayvideo = false
      }
      if (
        e.target.className &&
        e.target.className.indexOf('emoji_dialog') === -1 &&
        this.showEmoji
      ) {
        this.showEmoji = false
      }
    })
  },
  methods: {
    handleClose() {
    },
    ...mapActions('chat', ['historyMsg', 'newMsgAll']),
    // 修改消息状态
    ackById() {
      if ((this.message_ids.length === 0 || !this.unread) && !this.needAck) {
        return
      }
      let ackParam = {
        peer_uid: this.peer_uid, // status=2时不传
        peer_type: 0,
        status: 3, // 0:撤回, 1:未达，2:已达, 3:已读, 默认为2
        message_ids: this.message_ids, // 消息id
        dialog_id: this.dialog_id
      }
      chat.ackById(ackParam).then(res => {
        if (res.data.status === 0) {
          this.$store.state.chat.sendTimestamp = new Date()
        }
      })
    },
    pullHistoryMsg(h) {
      return new Promise((resolve, reject) => {
        this.msgParam.peer_uid = this.peer_uid
        this.msgParam.dialog_id = this.dialog_id
        if (this.hasMsgData) {
          this.historyMsg(this.msgParam).then(() => {
            this.loadding = false
            this.$nextTick(this.scroll(h))
            this.ackById()
            resolve()
          })
        } else {
          reject(new Error('没有数据'))
          this.loadding = false
        }
      })
    },
    playvideo(value) {
      this.isPlayvideo = true
      this.videoSrc = value
    },
    playVoice(e, index) {
      if (index !== this.voiceIndex) {
        this.isPlaying = false
        this.voiceIndex = index
      }
      let audio = e.currentTarget.getElementsByClassName('audio')[0]
      this.observeVoice(audio)
      if (!this.isPlaying) {
        audio.play()
        this.isPlaying = true
      } else {
        audio.pause()
        audio.currentTime = 0
        this.isPlaying = false
      }
    },
    observeVoice(self) {
      self.addEventListener('ended', () => {
        self.currentTime = 0
        this.isPlaying = false
      })
      self.addEventListener('paused', () => {
        self.currentTime = 0
        this.isPlaying = false
      })
      self.addEventListener('play', () => {
        self.currentTime = 0
        this.isPlaying = true
        let audios = document.getElementsByTagName('audio')
        let arr = []
        arr.forEach.call(audios, i => {
          i !== self && i.pause()
        })
      })
    },
    closeVideo() {
      this.isPlayvideo = false
    },
    inputFile(newFile, oldFile) {
      if (
        Boolean(newFile) !== Boolean(oldFile) ||
        oldFile.error !== newFile.error
      ) {
        if (!this.$refs.upload.active) {
          this.$refs.upload.active = true
        }
      }
    },
    inputFilter(newFile, oldFile) {
      if (newFile && !oldFile) {
        this.showpreview = true
        // 创建 `blob` 字段 用于缩略图预览
        newFile.blob = ''
        let URL = window.URL || window.webkitURL
        if (URL && URL.createObjectURL) {
          newFile.blob = URL.createObjectURL(newFile.file)
        }
      }
    },
    confirmImg(e) {
      this.showpreview = false
      this.sendMessage(e, 2)
    },
    sendMessage(e, type) {
      if (
        (e.keyCode === 13 && e.shiftKey) ||
        (!this.messageValue && type === 1) ||
        (!this.messageValue)
      ) {
        return
      }
      let param = {
        peer_uid: this.peer_uid, // 收听方用户id
        peer_type: 0, // 1 or 0(0标识peer_uid为customer_id,1标识peer_uid为shop_clients的id
        dialog_id: this.dialog_id,
        message_content: this.messageValue, // 消息内容
        type: type, // 消息类型：1-文字 2-图片 3-语音 4-附件 5-小视频
        service_source: 'crm', // 见service_source字段描述
        object_id: '', // service_source对应的id：例如采购id，供应id。。。
        sequence: '', // 消息序列标示
        meta: '{}' // 消息的额外信息
      }
      if (type === 2) {
        this.getImageParam(param)
      } else {
        this.$store.dispatch('chat/send', param).then(res => {
          let msg = {
            action_time: res.action_time,
            content: this.messageValue,
            customer_id: res.stream_data.cid,
            dialog_id: this.dialog_id,
            display_name: '',
            icon_url: '',
            id: res.id,
            img_prefix_url: '',
            is_mine: 1,
            meta: '{}',
            msg_type: 1,
            status: 1
          }
          if (!this.messageValue) { return }
          this.$store.dispatch('chat/updateHistoryMsg', msg).then(() => {
            this.messageValue = ''
          })
        })
      }
    },
    getImageParam(param) {
      let fixPrefix = this.$options.filters.fixPrefix
      let filename = fixPrefix(this.files[0].response.data.filename)
      let fileSize = this.files[0].file.size
      let image = new Image()
      image.src = filename
      image.onload = () => {
        let imgParam = {
          img_url: image.src,
          img_width: image.width,
          img_height: image.height,
          origin_img_url: image.src,
          origin_img_size: fileSize
        }
        param.message_content = '[图片]'
        param.service_source = 1
        param.meta = JSON.stringify(imgParam)
        this.$store.dispatch('chat/send', param).then(res => {
          let msg = {
            content: '[图片]',
            action_time: res.action_time,
            msg_type: 2,
            is_mine: 1,
            meta: param.meta,
            id: res.id,
            img_prefix_url: 'http://http://img.yimutian.com/',
            customer_id: res.stream_data.cid,
            status: 1
          }
          this.$store.dispatch('chat/updateHistoryMsg', msg).then(() => {
            this.messageValue = ''
          })
        })
      }
    },
    addEmoji(value) {
      this.showEmoji = false
      this.messageValue += value
      this.$refs.textarea.focus()
    },
    scroll(h) {
      let scrollHeight = this.$refs.list && this.$refs.list.scrollHeight
      h = h || 0
      if (this.$refs.list) {
        this.$refs.list.scrollTop = scrollHeight - h
      }
    },
    scrollMsg(e) {
      let scrollTop = e.target.scrollTop
      let scrollHeight = e.target.scrollHeight
      if (scrollTop <= 0 && this.hasMsgData && !this.loadding) {
        this.$store.state.chat.loadType = 2
        this.msgParam.start_id = this.message_list[0] && this.message_list[0].id
        if (this.msgParam.start_id) {
          this.loadding = true
          setTimeout(() => {
            this.pullHistoryMsg(scrollHeight)
          }, 1000)
        }
      }
    },
    throttle(e) {
      return utils.throttle(this.scrollMsg.bind(this, e), 200)()
    }
  },
}
</script>

<style lang="less" scoped>
@import '../../assets/chatList.less';
.chat_middle_top {
  position: relative;
  display: flex;
  align-items: center;
}
.usercard {
  margin-left: -6px;
  display: inline-block;
  width: 36px;
  height: 36px;
  background: url('http://img.yimutian.com/crm/5ddf9254b827736e3b2e50933e74bfe9.png') no-repeat center center;
  background-size: 100%;
  border: 10px solid transparent;
}
.el_btn {
  background: transparent url('http://img.yimutian.com/crm/5ddf9254b827736e3b2e50933e74bfe9.png') no-repeat center center; border: 0 none;
  background-size: 16px;
  position: absolute;
  top: 12px;
  margin-left: -6px;
}
.el_btn:hover,
.el_btn:active,
.el_btn:link,
.el_btn:focus,
.el_btn:visited {
  background-color: transparent;
}

.chat_middle_top .el-button {
  padding: 12px 20px !important;
}
</style>
